<template>
  <div>
    <img src="@/assets/img/bj_3.png" class="bjImg" alt="">
    <div class="boxCont">
      <div class="boxCont_left">
        <div class="boxCont_left_1 animate__animated animation_title">
          汰汰清单APP
        </div>
        <div class="boxCont_left_2 animate__animated animation_title">
          开发者：<span>石家庄车道科技有限公司</span>
        </div>
        <div class="boxCont_left_2 animate__animated animation_title">
          版本号：<span>1.0.1</span>
        </div>
        <div class="boxCont_left_2 animate__animated animation_title">
          更新时间：<span>2024.12.24</span>
        </div>
        <img src="@/assets/img/a_1.png" class="boxCont_left_3 animate__animated animation_title" alt="">
      </div>
      <div class="boxCont_right_one animate__animated animation_title" @mouseenter="showTooltip = true"
        @mouseleave="showTooltip = false">
        <div class="boxCont_right_one_cont" v-if="showTooltip == false">
          <img src="@/assets/img/a_2.png" class="boxCont_right_one_1" alt="">
          <div class="boxCont_right_one_2">汰汰清单 <span> Android</span></div>
          <div class="boxCont_right_one_3">支持安卓全版本</div>
          <div class="boxCont_right_one_4">下载</div>
        </div>
        <div class="boxCont_right_one_cont" v-if="showTooltip == true">
          <img src="@/assets/img/xiazai.png" class="boxCont_right_one_6" alt="">
          <div class="boxCont_right_one_2">手机扫码下载客户端</div>
          <div class="boxCont_right_one_3">请使用浏览器扫码直接下载</div>
          <div class="boxCont_right_one_5" @click="downLoad(1)">点击直接下载安装包</div>
        </div>
      </div>
      <div class="boxCont_right_one boxCont_right_two animate__animated animation_title">
        <div class="boxCont_right_one_cont">
          <img src="@/assets/img/a_3.png" class="boxCont_right_one_1" alt="">
          <div class="boxCont_right_one_2">汰汰清单 <span> IOS</span></div>
          <div class="boxCont_right_one_3">支持苹果全版本</div>
          <div class="boxCont_right_one_4" @click="downLoad(2)">下载</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 汰汰清单
  // @author: 刘嘉鑫
  export default {
    data() {
      return {
        showTooltip: false,
      }
    },
    mounted() { },
    methods: {
      // 下载
      downLoad(type) {
        if (type == 1) {
          this.$message({
            showClose: true,
            message: '下载中...',
            type: 'success',
            offset: 400
          });
          window.location.href = "http://note.xingnuo.tech/app/note.apk";
        }
        if (type == 2) {
          this.$message({
            showClose: true,
            message: '正在开发中，敬请期待！',
            type: 'success',
            offset: 400
          });
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .downToUp {
    animation-name: slideInUp !important;
  }

  @keyframes slideInUp {
    from {
      -webkit-transform: translate3d(0, 14%, 0);
      transform: translate3d(0, 14%, 0);
      visibility: visible;
    }

    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }


  .bjImg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .boxCont {
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    padding: 250px 160px 0;
  }

  .boxCont_left {

    .boxCont_left_1 {
      font-weight: 700;
      font-size: 54px;
      color: #2A303A;
      margin-bottom: 40px;
      letter-spacing: 6px;
    }

    .boxCont_left_2 {
      font-weight: 400;
      font-size: 17px;
      color: #333A47;
      margin-bottom: 20px;
      letter-spacing: 2px;

      span {
        color: #0057FE;
      }
    }

    .boxCont_left_3 {
      width: 96px;
      height: 96px;
      margin-top: 70px;
    }
  }

  .boxCont_right_one {
    background: #FFFFFF;
    border-radius: 40px;
    margin-left: auto;
    /* padding: 30px 0; */

    width: 29%;

    .boxCont_right_one_cont {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    .boxCont_right_one_1 {
      width: 72px;
      height: 72px;
      margin-bottom: 40px;
    }

    .boxCont_right_one_2 {
      font-weight: 400;
      font-size: 19px;
      color: #333A47;
      margin-bottom: 12px;
      letter-spacing: 2px;

      span {
        font-weight: 700;
        font-size: 22px;
      }
    }

    .boxCont_right_one_3 {
      font-weight: 400;
      font-size: 16px;
      color: #5D6574;
      margin-bottom: 30px;
      letter-spacing: 2px;
    }

    .boxCont_right_one_4 {
      background: #0057FE;
      border-radius: 66px;
      padding: 13px 30px;
      font-weight: bold;
      font-size: 17px;
      color: #FFFFFF;
      cursor: pointer;
    }

    .boxCont_right_one_5 {
      font-weight: 400;
      font-size: 17px;
      color: #0057FE;
      margin-top: 20px;
      cursor: pointer;
    }

    .boxCont_right_one_6 {
      width: 120px;
      height: 120px;
      margin-bottom: 20px;
    }
  }

  .boxCont_right_two {
    margin-left: 40px;
  }
</style>